import React, { useState } from "react";
import { AzureDevFaqs } from "../../components/faqData.js";

import Contact from "../../components/Contact.js";
import GetInTouch from "../../components/GetInTouch.js";
import AyanshtechAdvantage from "../../components/AyanshtechAdvantage.js";
import { Helmet } from "react-helmet-async";

const AzureEngineers = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };
    const scrollToContact = () => {
        const contactSection = document.getElementById("contact-section");
        contactSection.scrollIntoView({ behavior: "smooth" });
    };

    return (<>
        <Helmet>
            <meta name="description" content="Hire expert Azure Engineers in India to build scalable, secure, and high-performance cloud solutions. Get custom Azure development and cloud migration services for your business success." />
            <meta name="copyright" content="codeglim" />
            <meta property="og:title" content="Hire Expert Azure Engineers in India | Ayanshtech Solutions" />
            <meta property="og:site_name" content="Ayanshtech Solutions" />
            <meta property="og:url" content="https://ayanshtechnology.com/hire-azure-engineers" />
            <meta property="og:description" content="Hire expert Azure Engineers in India to build scalable, secure, and high-performance cloud solutions. Get custom Azure development and cloud migration services for your business success." />
            <meta property="og:type" content="website" />
            <meta property="og:image" content="https://ayanshtechnology.com/assets/logo.png" />

            <meta name="twitter:card" content="summary" />
            <meta name="twitter:site" content="@Ayanshtech Solutions" />
            <meta name="twitter:title" content="Hire Expert Azure Engineers in India | Ayanshtech Solutions" />
            <meta name="twitter:description" content="Hire expert Azure Engineers in India to build scalable, secure, and high-performance cloud solutions. Get custom Azure development and cloud migration services for your business success." />
            <meta name="twitter:image" content="https://ayanshtechnology.com/assets/logo.png" />

            <link rel="canonical" href="https://ayanshtechnology.com/hire-azure-engineers" />
            <title>Hire Expert Azure Engineers in India | Ayanshtech Solutions</title>
        </Helmet>
        <div className="min-h-screen flex flex-col items-center justify-center p-6">
            <div className=" p-4 w-full">
                <div className="flex flex-col lg:flex-row items-center lg:space-x-16 mt-10">
                    <div className="lg:w-3/4  lg:text-left ">
                        <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
                            Hire Expert Azure Engineers
                        </h1>
                        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 leading-relaxed mb-3">
                            Azure cloud engineering is essential for businesses aiming to leverage
                            scalable, secure, and cost-effective cloud infrastructure. At Ayanshtech,
                            we provide skilled Azure engineers proficient in technologies like Azure
                            DevOps, Azure Kubernetes Service (AKS), Azure Active Directory, and
                            Infrastructure as Code tools. Our team ensures your cloud platform is
                            reliable, secure, and optimized for seamless deployment and operations.
                            <br />
                            <br />
                            Whether you need cloud migration to Azure, custom cloud architecture
                            design, CI/CD pipeline implementation, or advanced features like Azure
                            security and monitoring, our Azure engineers have the expertise to meet
                            your requirements. Hire Azure engineers from Ayanshtech to create
                            robust, scalable, and future-ready cloud solutions tailored to your
                            business needs.
                        </p>
                        <p className="  text-gray-600 sm:text-lg md:text-xl lg:text-xl">
                            Starting from just <span className="font-bold">US $20/hour</span>
                        </p>
                        <button
                            onClick={scrollToContact}
                            className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold p-3 rounded-full mt-6"
                        >
                            Hire an Azure Engineer
                        </button>
                    </div>
                    <div className="flex w-full md:w-1/2 justify-center mt-5 mb10 lg:mb-0">
                        <img
                            src="\assets\images\homeImages\azureDev.png"
                            alt="Azure Cloud Engineering"
                            className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
                        />
                    </div>
                </div>
            </div>

            <div className="text-center mb-5 mt-10">
                <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
                    Key Skills of Our Azure Engineers
                </h2>
                <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
                    When you hire Azure professionals from our team, you gain access to
                    their deep expertise in cloud infrastructure and DevOps technologies, ensuring
                    exceptional performance and scalability for your cloud transformation
                    projects.
                </p>
            </div>

            <div className=" p-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    <div className="flex items-center space-x-4">
                        <img
                            src="\assets\icons\techIcons\icon1.png"
                            alt="icon"
                            className="w-10 h-10"
                        />
                        <p className="text-lg">Azure cloud architecture design and deployment</p>
                    </div>

                    <div className="flex items-center space-x-4">
                        <img
                            src="\assets\icons\techIcons\icon2.png"
                            alt="icon"
                            className="w-10 h-10"
                        />
                        <p className="text-lg">Azure DevOps and CI/CD pipeline setup</p>
                    </div>

                    <div className="flex items-center space-x-4">
                        <img
                            src="\assets\icons\techIcons\icon3.png"
                            alt="icon"
                            className="w-10 h-10"
                        />
                        <p className="text-lg">Azure Kubernetes Service (AKS) management</p>
                    </div>

                    <div className="flex items-center space-x-4">
                        <img
                            src="\assets\icons\techIcons\icon4.png"
                            alt="icon"
                            className="w-10 h-10"
                        />
                        <p className="text-lg">Infrastructure as Code (ARM, Bicep, Terraform)</p>
                    </div>

                    <div className="flex items-center space-x-4">
                        <img
                            src="\assets\icons\techIcons\icon5.png"
                            alt="icon"
                            className="w-10 h-10"
                        />
                        <p className="text-lg">Azure networking and security implementation</p>
                    </div>

                    <div className="flex items-center space-x-4">
                        <img
                            src="\assets\icons\techIcons\icon6.png"
                            alt="icon"
                            className="w-10 h-10"
                        />
                        <p className="text-lg">Cloud migration and optimization services</p>
                    </div>
                </div>
            </div>

            <div className="text-center mt-10  ">
                <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
                    Experienced Azure Engineers
                </h2>
                <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
                    Ayanshtech offers customizable hiring models to align with your
                    specific project needs, whether for short-term assignments or
                    long-term commitments.
                </p>
            </div>

            <div className=" ">
                <div className="flex flex-col md:flex-row items-center justify-between">
                    <div className="w-full md:w-1/3 p-4">
                        <img
                            src="\assets\images\homeImages\azureSol.png"
                            alt="Azure cloud solutions dashboard"
                            className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
                        />
                    </div>

                    <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="flex items-start space-x-4">
                            <img
                                src="\assets\icons\techIcons\icon7.png"
                                alt="icon"
                                className="w-10 h-10"
                            />
                            <div>
                                <p className="text-lg">
                                    Partner with skilled Azure engineers from Ayanshtech,
                                    proficient in delivering enterprise-grade cloud solutions.
                                </p>
                            </div>
                        </div>

                        <div className="flex items-start space-x-4">
                            <img
                                src="\assets\icons\techIcons\icon8.png"
                                alt="icon"
                                className="w-10 h-10"
                            />
                            <div>
                                <p className="text-lg">
                                    Evaluate and interview pre-screened cloud experts to find the ideal
                                    match for your team.
                                </p>
                            </div>
                        </div>

                        <div className="flex items-start space-x-4">
                            <img
                                src="\assets\icons\techIcons\icon9.png"
                                alt="icon"
                                className="w-10 h-10"
                            />
                            <div>
                                <p className="text-lg">
                                    Receive personalized guidance from our consultants to select
                                    the right Azure specialist for your cloud initiatives.
                                </p>
                            </div>
                        </div>

                        <div className="flex items-start space-x-4">
                            <img
                                src="\assets\icons\techIcons\icon10.png"
                                alt="icon"
                                className="w-10 h-10"
                            />
                            <div>
                                <p className="text-lg">
                                    Flexible hiring models ensure a perfect fit for both your
                                    budget and project requirements.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <AyanshtechAdvantage />
            <div className="h-[30px] md:h-[60px] lg:h-[80px]"></div>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center mb-16">
                FAQs
            </h2>
            <div className="flex flex-col md:flex-row justify-around mb-5  md:mb-4 lg:mb-5 item-center ">

                <div className="w-full  md:w-1/2 lg:w-[616px]  mb-8 md:mb-4 lg:mb-0">
                    {/* <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
                        FAQs
                    </h2> */}
                    {AzureDevFaqs.map((faq, index) => (
                        <div key={index} className="border-b-2 border-blue-300">
                            <button
                                onClick={() => toggleFAQ(index)}
                                className={` w-full text-left py-4 flex justify-between items-center focus:outline-none ${activeIndex === index
                                    ? "bg-blue-600 text-white px-5 rounded-2xl"
                                    : ""
                                    }`}
                            >
                                <span className="text-lg">{faq.question}</span>
                                <span className="text-2xl">
                                    {activeIndex === index ? "-" : "+"}
                                </span>
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 text-gray-700">{faq.answer}</div>
                            )}
                        </div>
                    ))}
                </div>

                <div id="contact-section" className="w-full md:w-1/2 lg:w-1/2">
                    {" "}
                    <Contact />
                </div>


            </div>
            <GetInTouch />
        </div>
    </>);
};

export default AzureEngineers;